import { CheckInObjectiveResponse } from '@/services/types/treatment-types';

export const DEFAULT_UNSURE_RESPONSE_NOTE = "I didn't ask";

export const getObjectiveResponseNote = (
  response: CheckInObjectiveResponse,
  currentNote?: string | null,
): string | null =>
  response === CheckInObjectiveResponse.COULD_NOT_COLLECT
    ? (currentNote ?? DEFAULT_UNSURE_RESPONSE_NOTE)
    : null;

export const shouldShowProviderAdditionalNotes = (
  stillTreatingResponse?: CheckInObjectiveResponse | null,
): boolean =>
  stillTreatingResponse == null ||
  stillTreatingResponse === CheckInObjectiveResponse.YES ||
  stillTreatingResponse === CheckInObjectiveResponse.NO;

export const shouldShowSecondaryProviderObjectives = (
  stillTreatingResponse?: CheckInObjectiveResponse | null,
): boolean => stillTreatingResponse === CheckInObjectiveResponse.YES;

export const shouldShowAppointmentObjective = (
  stillTreatingResponse?: CheckInObjectiveResponse | null,
  firstVisitResponse?: CheckInObjectiveResponse | null,
): boolean =>
  shouldShowSecondaryProviderObjectives(stillTreatingResponse) &&
  (firstVisitResponse == null ||
    firstVisitResponse === CheckInObjectiveResponse.NO);
